import { Inline } from '@etg/wings';
import { PartnerLogo } from '@eti/components';
import { useProperty } from '@eti/providers';
import { css } from '@eti/styles';

const listItemStyles = css`
  line-height: 0;
`;

const PaymentTrustSeals = () => {
  const { p } = useProperty();
  const paymentSeals = [...new Set<string>(p('Payment.PaymentSeals.SortOrder'))].slice(0, 3);

  return paymentSeals.length === 0 ? null : (
    <Inline alignY="center" as="ul" data-testid="payment-trust-seals" spacing={16}>
      {paymentSeals.map((id) => (
        <li className={listItemStyles} key={id}>
          <PartnerLogo collection="payment-providers" id={id.toLowerCase()} />
        </li>
      ))}
    </Inline>
  );
};

export default PaymentTrustSeals;
